module.exports = __webpack_public_path__ + "img/Punn-black-logo.93901665.png";